import Schedule from "@/features/projectSchedule";

export default function ProjectSchedule() {
  return <Schedule />;
}
